export default __webpack_public_path__ + "static/media/react.4efb1ffb.svg";